var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Group, Line, Path, } from 'fabric';
import { getClipPath } from './CanvasFormService';
import { mmToPixels } from './DecalEditorCanvasSizing';
import opentype from 'opentype.js';
export const CalculateMenuPosition = (dynamicMenuWidth, object, canvasContainer, zoom) => {
    const buffer = 70;
    object.setCoords();
    const containerRect = canvasContainer.getBoundingClientRect();
    const boundingRect = object.getBoundingRect();
    const objectCenterX = boundingRect.left + boundingRect.width / 2;
    let top = containerRect.top + boundingRect.top * zoom - buffer;
    let left = containerRect.left + objectCenterX * zoom - dynamicMenuWidth / 2;
    const minTop = containerRect.top - 70;
    if (top < minTop) {
        top = minTop;
    }
    const minLeft = containerRect.left - dynamicMenuWidth;
    const maxLeft = containerRect.left + containerRect.width;
    if (left < minLeft) {
        left = minLeft;
    }
    else if (left > maxLeft) {
        left = maxLeft;
    }
    return { top, left };
};
export function dataURLToBlob(dataURL) {
    var _a;
    const [header, base64] = dataURL.split(',');
    const contentType = ((_a = header.match(/:(.*?);/)) === null || _a === void 0 ? void 0 : _a[1]) || '';
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length)
        .fill(0)
        .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
}
export const exportForPrinting = (fabricCanvas, canvasSize, canvasType, canvasForms, holePlacement, uploadedImages) => {
    var _a, _b, _c, _d, _e;
    const realWidthPx = mmToPixels(canvasSize.width);
    const realHeightPx = mmToPixels(canvasSize.height);
    // Export canvas as PNG
    const imgData = fabricCanvas.toDataURL({
        format: 'png',
        multiplier: 0.4,
        quality: 1,
    });
    const clipPath = getClipPath(fabricCanvas, canvasSize);
    const objects = getCanvasObjectsDataOrginal(fabricCanvas, uploadedImages);
    const clipPathPoints = ((_b = (_a = fabricCanvas.clipPath) === null || _a === void 0 ? void 0 : _a.toJSON()) === null || _b === void 0 ? void 0 : _b.points) || [];
    const clipPathType = (clipPath === null || clipPath === void 0 ? void 0 : clipPath.type) || '';
    const clipPathSvg = ((_c = fabricCanvas.clipPath) === null || _c === void 0 ? void 0 : _c.toSVG()) || '';
    const clipPathWidth = ((_d = fabricCanvas.clipPath) === null || _d === void 0 ? void 0 : _d.width) || 0;
    const clipPathHeight = ((_e = fabricCanvas.clipPath) === null || _e === void 0 ? void 0 : _e.height) || 0;
    const canvasBackgroundColor = typeof fabricCanvas.backgroundColor === 'string'
        ? fabricCanvas.backgroundColor
        : '';
    return {
        objects,
        canvasSize,
        canvasType,
        canvasForms: canvasForms,
        holePlacement: holePlacement,
        canvasBackgroundColor,
        canvasRealWidthPx: realWidthPx,
        canvasRealHeightPx: realHeightPx,
        imgPreview: imgData,
        clipPathPoints,
        clipPathType,
        clipPathSvg,
        clipPathWidth,
        clipPathHeight,
        zoom: fabricCanvas.getZoom(),
        quantity: 1,
        exportedSvg: null,
    };
};
export const getCanvasObjectsDataOrginal = (fabricCanvas, uploadedImages) => {
    const objects = fabricCanvas
        .getObjects()
        .filter((obj) => ![
        'watermark',
        'watermark-pattern',
        'border-for-path',
        'hole-group',
    ].includes(obj.id || ''))
        .map((obj) => {
        let type;
        switch (obj.type) {
            case 'image':
                type = 'image';
                break;
            case 'path':
                type = 'path';
                break;
            case 'text':
            case 'i-text':
            case 'textbox':
                type = 'text';
                break;
            default:
                type = 'unknown';
                break;
        }
        const left = obj.left || 0;
        const top = obj.top || 0;
        const width = obj.width || 0;
        const height = obj.height || 0;
        const angle = obj.angle || 0;
        const scaleX = obj.scaleX || 1;
        const scaleY = obj.scaleY || 1;
        let imageObject = null;
        let iconObject = null;
        let textObject = null;
        if (type === 'image') {
            const imageObj = obj;
            const systemId = imageObj.get('systemId') || '';
            const imageSrc = uploadedImages.find((img) => img.systemId === systemId);
            if (imageSrc) {
                imageObject = {
                    imageSrc: (imageSrc === null || imageSrc === void 0 ? void 0 : imageSrc.imageSrc) || imageObj.getSrc(),
                    systemId: systemId || '',
                    fileName: (imageSrc === null || imageSrc === void 0 ? void 0 : imageSrc.fileName) || '',
                    maxSizeHighQualityMm: (imageSrc === null || imageSrc === void 0 ? void 0 : imageSrc.maxSizeHighQualityMm) || {
                        width: 0,
                        height: 0,
                    },
                    maxSizeMediumQualityMm: (imageSrc === null || imageSrc === void 0 ? void 0 : imageSrc.maxSizeMediumQualityMm) || {
                        width: 0,
                        height: 0,
                    },
                };
            }
        }
        else if (type === 'path') {
            iconObject = {
                fill: typeof obj.fill === 'string' ? obj.fill : '',
                stroke: typeof obj.stroke === 'string' ? obj.stroke : '',
                strokeWidth: obj.strokeWidth || 0,
                svg: obj === null || obj === void 0 ? void 0 : obj.toSVG(),
            };
        }
        else if (type === 'text') {
            const textObj = obj;
            textObject = {
                fontSize: textObj.fontSize || 0,
                fontFamily: textObj.fontFamily || '',
                text: textObj.text || '',
                fontWeight: (textObj.fontWeight || 'normal').toString(),
                fontStyle: textObj.fontStyle || 'normal',
                textDecoration: textObj.underline
                    ? textObj.underline.toString()
                    : 'none',
                textAlign: textObj.textAlign || 'left',
                fill: typeof textObj.fill === 'string' ? textObj.fill : '',
                stroke: typeof textObj.stroke === 'string' ? textObj.stroke : '',
                strokeWidth: textObj.strokeWidth || 0,
            };
        }
        return {
            type,
            left,
            top,
            width,
            height,
            angle,
            scaleX,
            scaleY,
            imageObject,
            iconObject,
            textObject,
        };
    });
    return objects;
};
function getFontPath(fontFamily, fontWeight, fontStyle) {
    let fontFileName = fontFamily;
    if (fontWeight === 'bold' && fontStyle === 'italic') {
        fontFileName += '-BoldItalic';
    }
    else if (fontWeight === 'bold') {
        fontFileName += '-Bold';
    }
    else if (fontStyle === 'italic') {
        fontFileName += '-Italic';
    }
    else {
        fontFileName += '-Regular';
    }
    return `fonts/${fontFileName}.ttf`;
}
export const convertTextToPaths = (textObject, canvas) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        textObject.initDimensions();
        textObject.setCoords();
        const bbox = textObject.getBoundingRect();
        const fontFamily = textObject.fontFamily || 'Poppins';
        const fontSize = textObject.fontSize || 175;
        const fontWeight = textObject.fontWeight || 'bold';
        const fontStyle = textObject.fontStyle || 'normal';
        const fill = textObject.fill || '#000000';
        const textAlign = textObject.textAlign || 'left';
        const lineHeightMultiplier = textObject.lineHeight || 1.16;
        const fontPath = getFontPath(fontFamily, fontWeight, fontStyle);
        const font = yield opentype.load(fontPath);
        // Dela upp texten i rader
        const textLines = textObject._textLines || textObject.text.split('\n');
        const pathGroup = new Group([]);
        const unitsPerEm = font.unitsPerEm;
        const ascenderHeight = (font.ascender / unitsPerEm) * fontSize;
        const descenderHeight = (font.descender / unitsPerEm) * fontSize;
        const totalHeight = ascenderHeight - descenderHeight;
        const uniformLineHeight = totalHeight * lineHeightMultiplier;
        // Calculate offsets for positioning
        const bboxLeftOffset = bbox.left - textObject.left;
        const bboxTopOffset = bbox.top - textObject.top;
        const leftAdjustment = bboxLeftOffset;
        const topAdjustment = bboxTopOffset +
            (textObject._getTopOffset ? textObject._getTopOffset() : 0);
        const linePositions = [];
        const lineOffsets = [];
        let currentYOffset = 0;
        for (let i = 0; i < textLines.length; i++) {
            lineOffsets.push(currentYOffset);
            const lineHeight = textObject.getHeightOfLine
                ? textObject.getHeightOfLine(i)
                : uniformLineHeight;
            currentYOffset += lineHeight;
        }
        let maxLineWidth = 0;
        // Loopa igenom varje rad
        for (let i = 0; i < textLines.length; i++) {
            const lineText = textLines[i];
            if (!lineText)
                continue;
            // Get the Y-offset for this line (baseline position)
            const adjustedYOffset = lineOffsets[i] + topAdjustment;
            // Skapa banor för den aktuella raden
            const pathData = font.getPath(lineText, 0, 0, fontSize, {
                kerning: true,
            });
            // Get the bounding box of the path data
            const pathDataBoundingBox = pathData.getBoundingBox();
            // Konvertera banorna till SVG path-data
            const pathString = pathData.toSVG(1);
            // Beräkna X-offset baserat på textAlign
            const lineWidth = font.getAdvanceWidth(lineText, fontSize);
            maxLineWidth = Math.max(maxLineWidth, lineWidth);
            let xOffset = pathDataBoundingBox.x1; // Start with the path's x1
            if (textObject._getLineLeftOffset) {
                xOffset += textObject._getLineLeftOffset(i);
            }
            else {
                if (textAlign === 'center') {
                    xOffset += (textObject.width - lineWidth) / 2;
                }
                else if (textAlign === 'right') {
                    xOffset += textObject.width - lineWidth;
                }
            }
            xOffset += leftAdjustment;
            // Calculate the Y position using the path's bounding box
            const pathTop = adjustedYOffset + pathDataBoundingBox.y1;
            const path = new Path(pathString, {
                left: xOffset,
                top: pathTop,
                fill: fill,
                stroke: null,
                strokeWidth: 0,
                className: 'object text',
                spotfill: 'sm_black',
            });
            pathGroup.add(path);
            if (textObject.underline) {
                // Calculate the underline offset below the baseline
                const underlineOffset = fontSize * 0.1; // Adjust this value to match the Textbox's underline position
                // Position the underline relative to the baseline
                const underlineY = adjustedYOffset + underlineOffset;
                // Use the bounding box's x1 and x2 for the start and end points
                const underlinePadding = fontSize * 0.02;
                const underlineStartX = pathDataBoundingBox.x1 -
                    underlinePadding +
                    xOffset -
                    pathDataBoundingBox.x1;
                const underlineEndX = pathDataBoundingBox.x2 +
                    underlinePadding +
                    xOffset -
                    pathDataBoundingBox.x1;
                // Make strokeWidth dynamic based on fontSize
                const strokeWidth = fontSize * 0.07;
                // Create the underline path with dynamic strokeWidth
                const underlinePath = new Line([underlineStartX, underlineY, underlineEndX, underlineY], {
                    stroke: fill,
                    strokeWidth: strokeWidth,
                    fill: '',
                    strokeDashArray: null,
                    strokeLinecap: 'butt',
                    strokeLinejoin: 'miter',
                    strokeMiterLimit: 4,
                    opacity: 1,
                    className: 'object text',
                    spotstroke: 'sm_black',
                });
                pathGroup.add(underlinePath);
            }
            // Track position for debugging
            linePositions.push({ line: i, text: lineText, y: pathTop });
        }
        // calculate group offset for text alignment when textarea is larger than text
        let groupXOffset = 0;
        if (textAlign === 'left') {
            groupXOffset = -(textObject.width - maxLineWidth) / 2;
        }
        else if (textAlign === 'right') {
            groupXOffset = (textObject.width - maxLineWidth) / 2;
        }
        // Set group properties
        pathGroup.set({
            left: textObject.left + groupXOffset, //offset group for text alignment when textarea is larger than text
            top: textObject.top,
            width: textObject.width,
            height: textObject.height,
            angle: textObject.angle,
            padding: 0,
            objectCaching: false,
            noScaleCache: false,
        });
        pathGroup.setCoords();
        canvas.add(pathGroup);
        canvas.renderAll();
        return pathGroup;
    }
    catch (error) {
        console.error('Error converting text to paths:', error);
        return null;
    }
});
export const drawCutLine = (svg) => __awaiter(void 0, void 0, void 0, function* () {
    let modifiedSvg = svg;
    // Find the clipPath element in the SVG
    const clipPathMatch = svg.match(/<clipPath id="CLIPPATH_\d+"[^>]*>([\s\S]*?)<\/clipPath>/);
    if (clipPathMatch) {
        // Extract the polygon or path element from the clipPath
        const polygonMatch = clipPathMatch[1].match(/<polygon[^>]*points="([^"]*)"[^>]*\/>/);
        const pathMatch = clipPathMatch[1].match(/<path[^>]*d="([^"]*)"[^>]*\/>/);
        let pathData = '';
        let transform = [1, 0, 0, 1, 0, 0]; // Default to identity matrix
        // Extract the transform from the clipPath element
        const transformMatch = clipPathMatch[1].match(/transform="matrix\(([^)]+)\)"/);
        if (transformMatch) {
            transform = transformMatch[1].split(' ').map(Number);
        }
        if (polygonMatch) {
            // Handle polygon (e.g., arrow shape)
            const points = polygonMatch[1].trim(); // Remove leading/trailing whitespace
            const pointPairs = points.split(' ').filter(pair => pair !== ''); // Remove empty pairs
            const pointsArray = pointPairs.map(pair => {
                const [x, y] = pair.split(',').map(Number);
                if (isNaN(x) || isNaN(y)) {
                    throw new Error(`Invalid point in clipPath: ${pair}`);
                }
                // Apply the transform: [a b c d e f]
                const a = transform[0], b = transform[1], c = transform[2], d = transform[3], e = transform[4], f = transform[5];
                const transformedX = a * x + c * y + e;
                const transformedY = b * x + d * y + f;
                return [transformedX, transformedY];
            });
            // Convert points to path data
            if (pointsArray.length > 0) {
                pathData = `M ${pointsArray[0][0]},${pointsArray[0][1]}`;
                for (let i = 1; i < pointsArray.length; i++) {
                    pathData += ` L ${pointsArray[i][0]},${pointsArray[i][1]}`;
                }
                pathData += ' Z';
            }
            else {
                console.warn('No valid points found in clipPath polygon');
            }
        }
        else if (pathMatch) {
            // Handle path (if the clipPath uses a <path> instead of a <polygon>)
            pathData = pathMatch[1];
            // Apply the transform to the path data (simplified for now; may need a library like svg-path-transform for complex paths)
        }
        else {
            console.warn('No polygon or path found in the clipPath');
        }
        if (pathData) {
            // Define the cutting path element with a spot color
            const cuttingPath = `
          <path
            d="${pathData}"
            style="stroke: #FF00FF; stroke-width: 0.1; fill: none;"
            class="cut-path"
            data-cut="true"
            spotcolor="CutContour"
            id="CutContour"                    
          />
        `;
            // Insert the cutting path just before the closing </svg> tag
            modifiedSvg = svg.replace('</svg>', `${cuttingPath}</svg>`);
        }
    }
    else {
        console.warn('No clipPath found in the SVG');
    }
    return modifiedSvg;
});
